// src/tools/ToolsIndex.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { tools } from './registry';
import { ToolHeader, ToolTitle, ToolSubtitle, Grid } from './ui';

const Card = styled(Link)`
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  padding: 1.4rem;
  border-radius: 16px;
  background: ${(p) => p.theme.gradients.card};
  border: 1px solid ${(p) => p.theme.colors.glassBorder};
  box-shadow: ${(p) => p.theme.shadows.card};
  transition: transform 0.22s ease, border-color 0.22s ease, box-shadow 0.22s ease;

  &:hover {
    transform: translateY(-4px);
    border-color: rgba(139, 92, 246, 0.35);
    box-shadow: ${(p) => p.theme.shadows.glow};
  }
`;

const IconWrap = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(139, 92, 246, 0.12);
  border: 1px solid rgba(139, 92, 246, 0.25);
  color: ${(p) => p.theme.colors.accentLight};
  font-size: 1.15rem;
`;

const CardName = styled.h3`
  font-size: 1.05rem;
  font-weight: 700;
`;

const CardDesc = styled.p`
  font-size: 0.85rem;
  color: ${(p) => p.theme.colors.muted};
  margin: 0;
  line-height: 1.5;
`;

const ToolsIndex: React.FC = () => (
  <>
    <ToolHeader>
      <ToolTitle>Developer Tools</ToolTitle>
      <ToolSubtitle>
        A small collection of everyday utilities. Everything runs locally in your
        browser — nothing is sent to a server.
      </ToolSubtitle>
    </ToolHeader>

    <Grid $min="240px">
      {tools.map((tool) => (
        <Card key={tool.slug} to={`/tools/${tool.slug}`}>
          <IconWrap>
            <tool.icon />
          </IconWrap>
          <CardName>{tool.name}</CardName>
          <CardDesc>{tool.description}</CardDesc>
        </Card>
      ))}
    </Grid>
  </>
);

export default ToolsIndex;
